export default __webpack_public_path__ + "static/media/Vydehi.f28921e1.png";